module.exports = __webpack_public_path__ + "img/dokanandroid-750.293217ef.jpg";